import colors from './colors';
import fonts from './fonts';
import sizes from './sizes';
import layout from './layout';

const variables = { ...colors, ...fonts, ...sizes, ...layout };

export default variables;
